import { render } from "./role.vue?vue&type=template&id=bf8518c2&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=bf8518c2&scoped=true&lang=css"
import "./role.vue?vue&type=style&index=1&id=bf8518c2&scoped=true&lang=scss"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8518c2"]])

export default __exports__